document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    // PERF: `ora.setHours(...)` mutates `ora` and returns a timestamp, so the previous
    // form `new Date(ora.setHours(24,0,0,0)) - ora` always evaluated to 0. That made the
    // timeout fire immediately, re-entering this function ~198x/second forever and
    // registering a new 24h interval on every pass. Compute the delay before mutating,
    // and let the chain re-schedule itself rather than stacking intervals.
    const mezzanotte = new Date(ora);
    mezzanotte.setHours(24, 0, 0, 0);
    const msFinoAllaMezzanotte = mezzanotte - ora;

    setTimeout(aggiornaData, msFinoAllaMezzanotte);
  }

  aggiornaData();
});

var coll = document.getElementsByClassName("u-accordion-item-title");
var i;
for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    var content = this.nextElementSibling;
    var isActive = this.classList.contains("active");
    var section = this.closest(".m-accordian-section");

    if (section) {
      section.querySelectorAll(".u-accordion-item-title").forEach(function(title) {
        title.classList.remove("active");
        var desc = title.nextElementSibling;
        if (desc) desc.style.maxHeight = null;
      });
    }

    if (!isActive && content) {
      this.classList.add("active");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}
var swiper = new Swiper(".mprogSwiper", {
      pagination: {
        el: ".swiper-pagination",
      },
  navigation: {
    nextEl: ".m-swiper-button-next",
    prevEl: ".m-swiper-button-prev",
  },
});
